import { EyeOutlined, HighlightOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form, Modal, notification, Typography } from 'antd';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateMouAction } from '../../../redux-store/mous-store';
import { markMouSignedMutation } from '../constants';
import { AgreementStatuses } from '../../loan-agreements/constants';

const { Title, Text, Paragraph } = Typography;

const MarkMouSignedBtn = ({ mou, setError, error, queryId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [showingModal, setShowingModal] = useState(null);
  const [markMouSigned] = useMutation(markMouSignedMutation);
  const dispatch = useDispatch();

  const handleFinish = useCallback(async () => {
    setError(null);
    setLoading(true);
    try {
      const result = await markMouSigned({
        variables: {
          mouId: mou._id,
        },
      });
      dispatch(updateMouAction(result.data.markMouSigned.mou, queryId));
      notification.success({
        message: 'Saved',
        description: 'Partnership Commitment Form updated successfully',
      });
      setShowingModal(null);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.log(err);
      setError(err.message);
    }
    setLoading(false);
  }, [setError, dispatch, queryId, markMouSigned, mou, onSuccess]);

  return (
    <>
      <Button
        loading={loading}
        icon={<HighlightOutlined />}
        onClick={() => setShowingModal(true)}
      >
        Mark Partnership Commitment Form Signed
      </Button>

      <Modal
        header={null}
        footer={null}
        visible={showingModal}
        closable={!loading}
        destroyOnClose={true}
        maskClosable={!loading}
        onCancel={() => {
          setShowingModal(false);
        }}
        styles={{ body: { paddingTop: 48 } }}
      >
        <Title level={3} style={{ textAlign: 'center', marginBottom: 32 }}>
          Mark Partnership Commitment Form Signed
        </Title>
        <Form onFinish={handleFinish} layout="vertical">
          <Form.Item>
            <Paragraph style={{ textAlign: 'center' }}>
              {`You are about to mark this Partnership Commitment Form signed. This is primarily for
              historically signed Partnership Commitment Form's that are now being entered into the AIMS
              system.`}
            </Paragraph>
            <Paragraph style={{ textAlign: 'center' }}>
              If this is a new Partnership Commitment Form, you should send the
              Partnership Commitment Form and have each party sign the
              agreement.
            </Paragraph>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <div
              style={{
                marginRight: -8,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Button
                onClick={() => setShowingModal(null)}
                htmlType="button"
                disabled={loading}
                style={{ marginLeft: 8, marginRight: 8, marginBottom: 8 }}
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                loading={loading}
                style={{ marginLeft: 8, marginRight: 8, marginBottom: 8 }}
              >
                Mark Signed
              </Button>
            </div>
          </Form.Item>
        </Form>
        {error && (
          <Text type="danger" style={{ marginTop: 16 }}>
            {error}
          </Text>
        )}
      </Modal>

      <style jsx>{``}</style>
      <style jsx global>{``}</style>
    </>
  );
};

export default MarkMouSignedBtn;
